import React from 'react';
import * as _ from 'lodash';
import { messageUtility } from '../../../utilities/messageUtility';
import {
  FormElement,
  FormDropdownRadio,
  FormDropdownClearButton,
} from '../../CommonFormComponents';

/**
 * 履歴取得ドロップダウン
 * @param param {array} 履歴取得のキーとなるオブジェクト
 * @param column {string} カラム名
 * @param set {function} 選択した値
 */
export class CommonHistoryDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldId: sessionStorage.getItem('field_id'),
      opened: false, // 開閉フラグ
      selected: null, // 選択したID
      options: {}, // 選択肢
      error: '', // バリデーションメッセージ
      isLoading: true, // ロード中フラグ
      info: '',
    };

    // ユニークID生成
    this.id = _.uniqueId();
    this.handleOpen = this.handleOpen.bind(this); // 開閉イベント
    this.handleSelectedRow = this.handleSelectedRow.bind(this); // 選択肢クリックイベント
    this.getHistories = this.getHistories.bind(this); // 取得
    this.parent = React.createRef();
    this.handleClickOutsideOfComponent = this.handleClickOutsideOfComponent.bind(
      this
    );
    this.onChange = this.onChange.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.isLoaded = false;
  }

  componentDidUpdate(prevProps) {
    if (this.state.opened) {
      // ドロップダウンが可視状態になった場合は、documentにコンポーネント外をclickしたかのイベントを追加する
      document.addEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }
    if (!this.state.opened) {
      // ドロップダウンが不可視状態になった場合は、documentのclickイベントを削除する
      document.removeEventListener(
        'click',
        this.handleClickOutsideOfComponent,
        false
      );
    }

    if (!_.isEqual(prevProps.resetKeys, this.props.resetKeys)) {
      this.isLoaded = false;
    }
  }

  componentWillUnmount() {
    document.removeEventListener(
      'click',
      this.handleClickOutsideOfComponent,
      false
    );
  }

  handleClickOutsideOfComponent = e => {
    // コンポーネント内クリックの場合は無視する
    if (
      !_.isNull(this.parent.current) &&
      this.parent.current.contains(e.target)
    ) {
      return;
    }
    // コンポーネント外クリックの場合はドロップダウンを不可視とする
    // イベントはstateにfalseが設定された際にremoveされる
    this.setState({ opened: false });
    // フォーカスアウト時のバリデーション
    if (_.isFunction(this.props.validate)) {
      this.props.validate(this.props.column);
    }
  };

  /**
   * 開閉イベント
   */
  handleOpen = () => {
    let updateValues = {};
    if (this.state.selected) {
      updateValues = { [this.props.column]: this.state.selected };
    }
    // 最初に開いた場合にAPI呼び出し
    if (!this.state.opened && !this.isLoaded) {
      this.setState(
        {
          selected: null,
          options: {},
          isLoading: true,
        },
        () => {
          this.getHistories();
        }
      );
    }
    // フォーカスアウト時のバリデーション
    if (this.state.opened && _.isFunction(this.props.validate)) {
      this.props.validate(this.props.column, updateValues);
    }
    this.setState({ opened: !this.state.opened });
  };

  /**
   * 選択肢クリックイベント
   * @param id {int} 選択したデータID
   * @param checked {bool}
   */
  handleSelectedRow = (id, checked) => {
    let selected = '';
    if (checked) {
      selected = id;
    }
    this.setState({ selected }, () => {
      this.props.set(this.props.column, selected);
      this.handleOpen();
    });
  };

  clearSelectedRow = () => {
    this.setState({ selected: null }, () => {
      this.props.set(this.props.column, '');
      this.handleOpen();
    });
  };

  /**
   * 履歴取得
   */
  async getHistories() {
    if (this.isLoaded) {
      this.setState({ isLoading: false });
      return;
    }

    const histories = await this.props.getHistories(this.state.fieldId);
    let options = {};
    if (!_.isEmpty(histories)) {
      _.each(histories, history => {
        if (history[this.props.column]) {
          options[history.id] = history;
        }
      });
      options = _.orderBy(options, 'id', 'desc');
    }
    this.setState({ options, isLoading: false });
    this.isLoaded = true;
  }

  onChange = e => this.props.set(this.props.column, e.target.value);

  onBlur = () => {
    _.isFunction(this.props.validate)
      ? this.props.validate(this.props.column)
      : null;
  };

  render() {
    const isFormListDefault = !!this.props.isFormListDefault;

    if (isFormListDefault && this.props.readOnly) {
      return (
        <FormElement>
          <div
            className={this.props.isTextArea && 'form-list__textare--disable'}
          >
            {this.props.value}
          </div>
        </FormElement>
      );
    }
    return (
      <FormElement
        validate={
          !this.props.useConstructionSiteCodeFlg &&
          this.props.error &&
          '必須です'
        }
        info={this.props.info && this.props.info}
      >
        {this.props.isTextArea ? (
          <textarea
            maxLength={this.props.maxLength}
            className='textarea'
            disabled={this.props.readOnly || this.props.isDisabledInput}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={this.props.value}
          />
        ) : (
          <input
            maxLength={this.props.maxLength}
            type='text'
            className={this.props.inputClassName}
            disabled={this.props.readOnly || this.props.isDisabledInput}
            onChange={this.onChange}
            onBlur={this.onBlur}
            value={this.props.value}
          />
        )}
        {!this.props.readOnly && (
          <div
            id='form-dropdown'
            className='dropdown-multi-select dropdown-multi-select__history-search'
            ref={this.parent}
          >
            <div className='dropdown-multi-select__header'>
              {isFormListDefault ? (
                <button
                  id='form-dropdown-btn'
                  className='btn-fixedsize--sub'
                  onClick={() => this.handleOpen()}
                >
                  履歴から選択
                </button>
              ) : (
                <div className='--spacearound-xl-2 --spacearound-lg-2 --spacearound-md-2 --spacearound-xs-2'>
                  <button
                    id='form-dropdown-btn'
                    className='btn-fixedsize--sub'
                    onClick={() => this.handleOpen()}
                  >
                    履歴から選択
                  </button>
                </div>
              )}
            </div>
            {this.state.opened && (
              <div
                id='form-dropdown-list'
                className='dropdown dropdown--dropdown-list show'
              >
                <div className='dropdown__item dropdown__item--wide dropdown__item--hidden'>
                  {this.props.isOptional && (
                    <div className='dropdown-single-select__item'>
                      <FormDropdownClearButton
                        onClick={this.clearSelectedRow}
                      />
                    </div>
                  )}
                  <div className='dropdown-multi-select__item'>
                    <div className='dropdown-multi-select__scroll'>
                      <ul className='single-select'>
                        {this.state.isLoading && <div className='indicator' />}
                        {this.state.isLoading ? null : _.size(
                            this.state.options
                          ) > 0 ? null : (
                          <div className='table-has-no-data'>
                            <div className='table-has-no-data__message'>
                              {messageUtility.getMessage('I-000-046')}
                            </div>
                          </div>
                        )}
                        {_.map(this.state.options, option => (
                          <FormDropdownRadio
                            key={option.id}
                            option={option}
                            checked={
                              this.state.selected === option[this.props.column]
                            }
                            targetId={this.id}
                            column={this.props.column}
                            handleSelectedRow={this.handleSelectedRow}
                            forId={'single-latest-registration-history'}
                          />
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </FormElement>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dropdowns/single/CommonHistoryDropdown.jsx